
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CasisManufacturerMultiFilter extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: number[];
    changeTimer: any = null;

    get loading() { return this.$store.state.manufacturer.loading; }
    get manufacturers() { return this.$store.state.manufacturer.activeList; }
    get allIds() { return this.manufacturers.map((manufacturer: any) => manufacturer.id); }
    get allSelected() {
        return this.allIds.length > 0 && this.allIds.every((id: number) => this.value.includes(id));
    }
    get someSelected() { return this.value.length > 0 && !this.allSelected; }

    async mounted() {
        if (!this.$store.state.manufacturer.activeList.length) {
            await this.$store.dispatch({ type: 'manufacturer/getAllActive' });
        }
    }

    change(value: number[]) {
        this.$emit('input', value || []);
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(() => this.$emit('change'), 350);
    }

    toggleAll() {
        this.change(this.allSelected ? [] : [...this.allIds]);
    }
}
